import { arrayOf, number, objectOf, string } from 'prop-types';
import React from 'react';
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown as Dropdown,
} from 'reactstrap';

import ApprovalStatus from '../../approval/ApprovalStatus';
import { changeApprovalShape, userShape } from '../../prop-types';
import UserLink from '../../users/UserLink';
import { approvalStatuses } from '../constants';
import { isApprovalReviewed } from '../utils';
import PendingReviews from './PendingReviews.container';

function Approvals({
  approvals,
  usersById,
  changeRequestId,
  campaignId,
  approvalRoles,
  currentUserRoles,
}) {
  const pendingApprovals = approvals.filter(
    approval => approval.status === approvalStatuses.pending,
  );
  const reviewedApprovalsCount = approvals.length - pendingApprovals.length;

  return (
    <>
      <div className="d-flex justify-content-between">
        <Dropdown>
          <DropdownToggle size="sm" caret>
            {reviewedApprovalsCount}/{approvals.length} granted
          </DropdownToggle>
          <DropdownMenu>
            {approvals.map(approval => {
              const reviewer = usersById[approval.reviewedBy];
              return (
                <span
                  key={approval.id}
                  className="dropdown-item d-flex align-items-center"
                  role="menuitem"
                >
                  <ApprovalStatus className="mr-2" status={approval.status} />
                  {approval.reviewerType}
                  {isApprovalReviewed(approval) && (
                    <UserLink className="ml-2" model={reviewer} />
                  )}
                </span>
              );
            })}
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className="mt-3" />
      <PendingReviews
        pendingApprovals={pendingApprovals}
        currentUserRoles={currentUserRoles}
        approvalRoles={approvalRoles}
        changeRequestId={changeRequestId}
        campaignId={campaignId}
      />
    </>
  );
}

Approvals.propTypes = {
  approvals: arrayOf(changeApprovalShape.isRequired).isRequired,
  approvalRoles: arrayOf(string).isRequired,
  currentUserRoles: arrayOf(string).isRequired,
  usersById: objectOf(userShape.isRequired).isRequired,
  campaignId: number.isRequired,
  changeRequestId: number.isRequired,
};

export default Approvals;
